import {
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  ReactiveStatel8ixobo86msn as ReactiveState,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
} from '../core/ReactiveState.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  getValue6qi464mhg2s5 as getValue,
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens_1,
  lens26es9640ifscs as lens_2,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
  get_state389x218zizu8a as get_state,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  Listenable3m4zqvjcbvczy as Listenable,
} from '../core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { awaitOnce2ui7qqi9bvdeq as awaitOnce } from '../context/DependencyChangeListener.mjs';
import {
  BaseReactive302n39o7i5yop as BaseReactive,
  BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue,
} from '../core/abstracts.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_set__cb7isu($this, value, $completion) {
  var transformed = $this.bap_1(value);
  $this.uas(_ReactiveState___init__impl__fvdp9b($this.sas_1(transformed)));
  var tmp = $this.ras_1.gah(transformed, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var SetLensClass;
function SetLens() {
  if (SetLensClass === VOID) {
    class $ extends Lens() {
      static cap(source, get, set) {
        var $this = this.vas(source, get);
        $this.bap_1 = set;
        return $this;
      }
      gah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, 'SetLens', VOID, VOID, [Lens(), MutableReactive()], [1]);
    SetLensClass = $;
  }
  return SetLensClass;
}
function *_generator_set__cb7isu_0($this, value, $completion) {
  var tmp = awaitOnce($this.ras_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var transformed = $this.iap_1(tmp, value);
  $this.uas(_ReactiveState___init__impl__fvdp9b($this.sas_1(transformed)));
  var tmp_0 = $this.ras_1.gah(transformed, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var ModifyLensClass;
function ModifyLens() {
  if (ModifyLensClass === VOID) {
    class $ extends Lens() {
      static jap(source, get, modify) {
        var $this = this.vas(source, get);
        $this.iap_1 = modify;
        return $this;
      }
      gah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu_0.bind(VOID, this, value), $completion);
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, 'ModifyLens', VOID, VOID, [Lens(), MutableReactive()], [1]);
    ModifyLensClass = $;
  }
  return ModifyLensClass;
}
var LensClass;
function Lens() {
  if (LensClass === VOID) {
    class $ extends BaseReactive() {
      static vas(source, get) {
        var $this = this.gal();
        $this.ras_1 = source;
        $this.sas_1 = get;
        $this.tas_1 = null;
        return $this;
      }
      uas(value) {
        super.pah(value);
      }
      pah(value) {
        return this.uas(value);
      }
      was() {
        if (this.tas_1 == null) {
          var tmp0 = this.ras_1.qah();
          var tmp2 = this.sas_1;
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.map' call
            var tmp;
            var tmp_0 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            if (tmp_0 instanceof InternalReactiveNotReady()) {
              tmp = true;
            } else {
              var tmp_1 = _ReactiveState___get_raw__impl__92ipya(tmp0);
              tmp = tmp_1 instanceof InternalReactiveThrownException();
            }
            if (tmp) {
              tmp$ret$0 = new (ReactiveState())(tmp0) instanceof ReactiveState() ? tmp0 : THROW_CCE();
              break $l$block_1;
            }
            var tmp_2 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            if (tmp_2 instanceof InternalReactiveWrapper())
              try {
                var tmp_3 = _ReactiveState___get_raw__impl__92ipya(tmp0).rah_1;
                tmp$ret$0 = _ReactiveState___init__impl__fvdp9b(tmp2((tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE()));
                break $l$block_1;
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  tmp$ret$0 = Companion_getInstance().uah(e);
                  break $l$block_1;
                } else {
                  throw $p;
                }
              }
            var tmp_4;
            try {
              tmp_4 = _ReactiveState___init__impl__fvdp9b(tmp2(_ReactiveState___get_raw__impl__92ipya(tmp0)));
            } catch ($p) {
              var tmp_5;
              if ($p instanceof Exception()) {
                var e_0 = $p;
                tmp_5 = Companion_getInstance().uah(e_0);
              } else {
                throw $p;
              }
              tmp_4 = tmp_5;
            }
            tmp$ret$0 = tmp_4;
          }
          super.pah(tmp$ret$0);
        }
        return super.qah();
      }
      qah() {
        return this.was();
      }
      ial() {
        super.ial();
        var tmp0 = this.ras_1.qah();
        var tmp2 = this.sas_1;
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.map' call
          var tmp;
          var tmp_0 = _ReactiveState___get_raw__impl__92ipya(tmp0);
          if (tmp_0 instanceof InternalReactiveNotReady()) {
            tmp = true;
          } else {
            var tmp_1 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            tmp = tmp_1 instanceof InternalReactiveThrownException();
          }
          if (tmp) {
            tmp$ret$0 = new (ReactiveState())(tmp0) instanceof ReactiveState() ? tmp0 : THROW_CCE();
            break $l$block_1;
          }
          var tmp_2 = _ReactiveState___get_raw__impl__92ipya(tmp0);
          if (tmp_2 instanceof InternalReactiveWrapper())
            try {
              var tmp_3 = _ReactiveState___get_raw__impl__92ipya(tmp0).rah_1;
              tmp$ret$0 = _ReactiveState___init__impl__fvdp9b(tmp2((tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE()));
              break $l$block_1;
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                tmp$ret$0 = Companion_getInstance().uah(e);
                break $l$block_1;
              } else {
                throw $p;
              }
            }
          var tmp_4;
          try {
            tmp_4 = _ReactiveState___init__impl__fvdp9b(tmp2(_ReactiveState___get_raw__impl__92ipya(tmp0)));
          } catch ($p) {
            var tmp_5;
            if ($p instanceof Exception()) {
              var e_0 = $p;
              tmp_5 = Companion_getInstance().uah(e_0);
            } else {
              throw $p;
            }
            tmp_4 = tmp_5;
          }
          tmp$ret$0 = tmp_4;
        }
        super.pah(tmp$ret$0);
        var tmp_6 = this;
        tmp_6.tas_1 = this.ras_1.tah(() => {
          var tmp0 = this.ras_1.qah();
          var tmp2 = this.sas_1;
          var tmp$ret$1;
          $l$block_4: {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.map' call
            var tmp;
            var tmp_0 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            if (tmp_0 instanceof InternalReactiveNotReady()) {
              tmp = true;
            } else {
              var tmp_1 = _ReactiveState___get_raw__impl__92ipya(tmp0);
              tmp = tmp_1 instanceof InternalReactiveThrownException();
            }
            if (tmp) {
              tmp$ret$1 = new (ReactiveState())(tmp0) instanceof ReactiveState() ? tmp0 : THROW_CCE();
              break $l$block_4;
            }
            var tmp_2 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            if (tmp_2 instanceof InternalReactiveWrapper())
              try {
                var tmp_3 = _ReactiveState___get_raw__impl__92ipya(tmp0).rah_1;
                tmp$ret$1 = _ReactiveState___init__impl__fvdp9b(tmp2((tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE()));
                break $l$block_4;
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  tmp$ret$1 = Companion_getInstance().uah(e);
                  break $l$block_4;
                } else {
                  throw $p;
                }
              }
            var tmp_4;
            try {
              tmp_4 = _ReactiveState___init__impl__fvdp9b(tmp2(_ReactiveState___get_raw__impl__92ipya(tmp0)));
            } catch ($p) {
              var tmp_5;
              if ($p instanceof Exception()) {
                var e_0 = $p;
                tmp_5 = Companion_getInstance().uah(e_0);
              } else {
                throw $p;
              }
              tmp_4 = tmp_5;
            }
            tmp$ret$1 = tmp_4;
          }
          super.pah(tmp$ret$1);
          return Unit_instance;
        });
      }
      jal() {
        super.jal();
        var tmp0_safe_receiver = this.tas_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.tas_1 = null;
      }
    }
    initMetadataForClass($, 'Lens');
    LensClass = $;
  }
  return LensClass;
}
var SetValueLensClass;
function SetValueLens() {
  if (SetValueLensClass === VOID) {
    class $ extends ValueLens() {
      static qap(source, get, set) {
        var $this = this.cat(source, get);
        $this.pap_1 = set;
        return $this;
      }
      mam(value) {
        var transformed = this.pap_1(value);
        super.dat(this.aat_1(transformed));
        this.zas_1.mam(transformed);
      }
      dat(value) {
        return this.mam((value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      f2() {
        return super.f2();
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).nam = getValue;
    protoOf($).cak = valueSet;
    protoOf($).gah = set;
    protoOf($).pam = setValue;
    protoOf($).tak = lens_1;
    protoOf($).bak = lens_2;
    initMetadataForClass($, 'SetValueLens', VOID, VOID, [ValueLens(), MutableReactiveValue()], [1]);
    SetValueLensClass = $;
  }
  return SetValueLensClass;
}
var ModifyValueLensClass;
function ModifyValueLens() {
  if (ModifyValueLensClass === VOID) {
    class $ extends ValueLens() {
      static xap(source, get, modify) {
        var $this = this.cat(source, get);
        $this.wap_1 = modify;
        return $this;
      }
      mam(value) {
        var transformed = this.wap_1(this.zas_1.f2(), value);
        super.dat(this.aat_1(transformed));
        this.zas_1.mam(transformed);
      }
      dat(value) {
        return this.mam((value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      f2() {
        return super.f2();
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).nam = getValue;
    protoOf($).cak = valueSet;
    protoOf($).gah = set;
    protoOf($).pam = setValue;
    protoOf($).tak = lens_1;
    protoOf($).bak = lens_2;
    initMetadataForClass($, 'ModifyValueLens', VOID, VOID, [ValueLens(), MutableReactiveValue()], [1]);
    ModifyValueLensClass = $;
  }
  return ModifyValueLensClass;
}
var ValueLensClass;
function ValueLens() {
  if (ValueLensClass === VOID) {
    class $ extends BaseReactiveValue() {
      static cat(source, get) {
        // Inline function 'kotlin.let' call
        var tmp$ret$0 = get(source.f2());
        var $this = this.vao(tmp$ret$0);
        $this.zas_1 = source;
        $this.aat_1 = get;
        $this.bat_1 = null;
        return $this;
      }
      dat(value) {
        super.mam(value);
      }
      mam(value) {
        return this.dat((value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      f2() {
        if (this.bat_1 == null) {
          var tmp0 = this.zas_1.f2();
          // Inline function 'kotlin.let' call
          var tmp$ret$0 = this.aat_1(tmp0);
          super.mam(tmp$ret$0);
        }
        return super.f2();
      }
      ial() {
        super.ial();
        var tmp0 = this.zas_1.f2();
        // Inline function 'kotlin.let' call
        var tmp$ret$0 = this.aat_1(tmp0);
        super.mam(tmp$ret$0);
        var tmp = this;
        tmp.bat_1 = this.zas_1.tah(() => {
          var tmp0 = this.zas_1.f2();
          // Inline function 'kotlin.let' call
          var tmp$ret$1 = this.aat_1(tmp0);
          super.mam(tmp$ret$1);
          return Unit_instance;
        });
      }
      jal() {
        super.jal();
        var tmp0_safe_receiver = this.bat_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.bat_1 = null;
      }
    }
    initMetadataForClass($, 'ValueLens');
    ValueLensClass = $;
  }
  return ValueLensClass;
}
function lens_3(_this__u8e3s4, get) {
  return Lens().vas(_this__u8e3s4, get);
}
function lens_4(_this__u8e3s4, get) {
  return ValueLens().cat(_this__u8e3s4, get);
}
function lensListenable(_this__u8e3s4, get) {
  var tmp = new (lensListenable$1())(_this__u8e3s4);
  return ValueLens().cat(tmp, (it) => get());
}
var lensListenable$1Class;
function lensListenable$1() {
  if (lensListenable$1Class === VOID) {
    class $ {
      constructor($this_lensListenable) {
        this.eat_1 = $this_lensListenable;
      }
      fat() {
        return Unit_instance;
      }
      f2() {
        this.fat();
        return Unit_instance;
      }
      tah(listener) {
        return this.eat_1.tah(listener);
      }
      iaj() {
        return this.eat_1.iaj();
      }
    }
    protoOf($).qah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [ReactiveValue(), Listenable()]);
    lensListenable$1Class = $;
  }
  return lensListenable$1Class;
}
//region block: exports
export {
  ModifyLens as ModifyLens104zsbx7gwa6e,
  ModifyValueLens as ModifyValueLenspp00mwqm1elc,
  SetLens as SetLens2527bvop19mpo,
  SetValueLens as SetValueLensuxj8ukufftbv,
  lensListenable as lensListenable3n4xxl63wcyqk,
  lens_4 as lens3m3nj3zkwtu6r,
  lens_3 as lens27v59dqa1oc3r,
};
//endregion

//# sourceMappingURL=abstracts.mjs.map
